import Fernet from 'fernet';
import axios from 'axios'; 

export const authProvider = {
    login: async ({ username, password }) => {
      
      const handlelogin = async()=>{

        const key = '8y4Ia5t_jQpDr_PNlpSvye8Dmeft1HwnsC1OadsDRaI=';
        const dataList = [username, password];
        const msgStr = dataList.join(':');
        const secret = new Fernet.Secret(key);
        const token = new Fernet.Token({
          secret: secret,
          time: Date.now(),
        });
        const encryptedMessage = token.encode(msgStr);

        try {
          const response = await axios.get(`https://console.ffeleven.com/administration/num_reporting/auto_login?token=${encryptedMessage}`,{ withCredentials: true });
          console.log(response.data)
          if (response.data.status === "SUCCESS") {
            return true;
          } else {
            return false;  
          }
      
        } catch (error) {
          console.error('Network or fetch error:', error);
          return false; 
        }

      }

      const status = await handlelogin();

      if (status) {
        localStorage.setItem('auth', 'true');
        localStorage.setItem('username',username);
        return Promise.resolve();
      }else{
        return Promise.reject('Invalid credentials');
      }      
    },
    logout: () => {
      if(localStorage.getItem('auth') && localStorage.getItem("username")){
        localStorage.clear();
        return Promise.resolve();
      }
      return Promise.reject('Error in logging out !');
    },
    checkAuth: () => {
      return localStorage.getItem('auth') ? Promise.resolve() : Promise.reject();
    },
    checkError: (error) => Promise.reject(error),
    getPermissions: () => Promise.resolve(),
  };